import React, { useEffect, useState } from 'react'
import { Button, Collapse } from '@mui/material';
import BucketFilled from '../../Assetes/Images/kfc-basket.svg'
import { priceunit } from '../../Components/client-config';
import { connect, useSelector } from 'react-redux';
import { orderDetail } from '../../Redux/actions/menu';
import domPurify from '../../Components/dompurify';
import { useTranslation } from 'react-i18next';
import { DiscountDisplay } from '../../Components/DiscountDisplay';


function OrderHistoryDetail(props?: any) {
  const orderDetail = useSelector((state: any) => state.menu.orderDetail);
  const [orderItems, setOrderItems] = useState(orderDetail.orderItems)
  const [value, setValue] = useState(0);

  function handleCollpase(currentIndex: any) {
    orderItems[currentIndex].collapseIn = !orderItems[currentIndex].collapseIn;
    setOrderItems(orderItems)
    setValue(value + 1)
  }
  const { t } = useTranslation();


  return (
    <div>
      <div className="w-100">
        <div className="history-slip-box">

          <div className='instructions-box '>
            <div className='bucket-img'>
              <img src={BucketFilled} alt="" />
              <h5 className='mt-3'>{t("YOUR_ORDER")}</h5>
            </div>
            <div className='price-info pt-2'>
              <h6>{t("ORDER_NUMBER")}</h6>
              <h5>{orderDetail.order.order_id}</h5>
            </div>
            <div className='price-info pt-2'>
              <h6>{t("ORDER_CHANNEL")}: </h6>
              <h5>{orderDetail.order.delivery_status}</h5>
            </div>
            <div className='price-info pt-2'>
              <h6>{t("STORE")}: </h6>

              <h5>{orderDetail.order.store_name}</h5>
            </div>
            <div className='price-info pt-2 border-bottom'>
              <h6>{(orderDetail && orderDetail.order && orderDetail.order.delivery_status == 'Pickup') ? t("STORE_ADDRESS") : t("DELIVERY_ADDRESS")}:</h6>
              <h5>{(orderDetail && orderDetail.order) && orderDetail.order.delivery_status == 'Pickup' ? orderDetail.order && domPurify.sanitize(orderDetail.order.address) : orderDetail.order && domPurify.sanitize(orderDetail.order.delivery_address)}</h5>
            </div>
            
            {orderItems?.map((item: any, index: any) => {
              return <div className='order-added mt-3 mb-3' key={index}>
                <div className='text-start'>
                  { item?.item_name ? <h6>{item?.item_name}: {item?.order_item_quantity}</h6> : null }
                  { item?.combo_name ? <h6>{item?.combo_name}: {item?.order_item_quantity}</h6> : null }
                  { item?.donation_id ? <h6>{t("DONATION")}: {item?.order_item_quantity}</h6> : null }
                  {(item.modifiers && JSON.parse(item.modifiers) && JSON.parse(item.modifiers).length > 0) &&
                    <Button
                      onClick={() => handleCollpase(index)}
                      aria-controls="example-fade-text"
                      aria-expanded={item.collapseIn}
                      className='bg-theme p-0 track-detail px-1 font-medium mt-1'

                      variant="contained" color="error"
                    >{t("DETAILS")}<i className={!item.collapseIn ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line"}></i></Button>}
                  <Collapse in={item.collapseIn}>
                    <div id="example-fade-text">
                      <div className="item-quantity collapse show" id="example-collapse-text" >
                        {item.modifiers && JSON.parse(item.modifiers) && JSON.parse(item.modifiers).length > 0 &&
                          JSON.parse(item.modifiers).map((obj: any) => {
                            return <div className="d-flex justify-content-between px-2">
                              <li>{obj.modifier_name} x {obj.quantity}</li>
                            </div>
                          })
                        }
                      </div>
                    </div>
                  </Collapse>
                </div>
                <h5>{priceunit} {item?.order_item_grossprice}</h5>
              </div>
            })}
            <div className='price-info border-top pt-2'>
              <h6>{t("SUBTOTAL")}: </h6>
              <h5>{priceunit} {orderDetail?.order?.order_netprice}</h5>
            </div>
            {orderDetail && orderDetail.order && (orderDetail.order.delivery_status != 'Pickup') &&
              <div className='price-info pt-2'>
                <h6>{t("DELIVERY_FEE")}: </h6>
                <h5>{orderDetail.order.delivery_status === "Delivery" ? orderDetail.order.delivery_fee : "0"}</h5>
              </div>
            }
            {orderDetail?.order?.pos_service_fee >0 && <div className='price-info pt-2'>
              <h6>{t("POS_FEE")}: </h6>
              <h5>{priceunit} {orderDetail?.order?.pos_service_fee}</h5>
            </div>}
            {orderDetail?.order?.tax_amount > 0 && 
              <div className='price-info pt-2'>
                <h6>{t("GST")} {orderDetail?.order?.tax_percent ? `( ${Math.round(orderDetail.order.tax_percent)} % )` : ''}: </h6>
                <h5>{priceunit} {Math.round(orderDetail?.order?.tax_amount)}</h5>
              </div>
            }
            <DiscountDisplay
              amount={orderDetail?.order?.discount || 0}
              label="DISCOUNT"
              className="price-info pt-2"
            />
            <DiscountDisplay
              amount={orderDetail?.order?.coupon_discount_value || 0}
              label="VOUCHER"
              couponCode={orderDetail?.order?.coupon_code}
              className="price-info pt-2"
            />
            <div className='price-info border-top pt-2'>
              <h6>{t("TOTAL")} </h6>
              <h5>{priceunit} {orderDetail?.order?.order_grossprice}</h5>
            </div>
            <div className='price-info border-top pt-2'>
              <h6>{t("PAID_WITH")} {orderDetail.order.payment_method} </h6>
              <h5>{priceunit} {orderDetail?.order?.order_grossprice}</h5>
            </div>
          </div>

        </div>
        <div className='slip-box'>

        </div>
      </div>
    </div>
  )
}

export default connect(null, null)(OrderHistoryDetail);
